import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Overview from '@/components/Overview'
import AuthComponent from '@mcity/mcity-vue-auth/src/components/AuthComponent.vue'
import { checkRequiresAuth } from '@mcity/mcity-vue-auth/dist/router/beforeEachHooks'

Vue.use(Router)

const testMode = !(process.env.VUE_APP_TESTING === 'true')
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/dataset/:key',
      name: 'Dataset',
      component: () => import('@/components/DatasetDashboard'),
      meta: {
        requiresAuth: testMode,
        requiresApproved: true
      },
      beforeEnter: (to, from, next) => {
        // Prevents accessing invalid project id
        if (parseInt(to.params.key)) {
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/dataset/:key/edit',
      name: 'DatasetEdit',
      component: () => import('@/components/DatasetDashboard'),
      props: { editMode: true },
      meta: {
        requiresAuth: testMode,
        requiresApproved: true
      },
      beforeEnter: (to, from, next) => {
        // Stops PI users from accessing normal edit mode
        if (store.getters.isUserAdmin) {
          next()
        } else {
          next(`/dataset/${to.params.key}`)
        }
        // Prevents accessing invalid dataset id
        if (parseInt(to.params.key)) {
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/',
      component: Overview,
      meta: {
        requiresAuth: testMode,
        requiresApproved: true
      }
    },
    {
      path: '/authorized',
      name: 'OverviewAuth',
      components: {
        auth: AuthComponent
      },
      meta: {
        authorized: true
      }
    },
    {
      path: '/new',
      name: 'New',
      component: () => import('@/components/NewDataset'),
      meta: {
        requiresAuth: testMode,
        requiresApproved: true
      }
    },
    {
      path: '*',
      name: 'Error',
      component: () => import('@mcity/mcity-vue-shared/components/NotFound')
    }
  ]
})

router.beforeEach(checkRequiresAuth.bind({ $store: store }))

export default router
